import { jsx, jsxs } from "react/jsx-runtime";
import { JsonParser } from "./JsonParser.js";
const isDevelopmentEnvironment = () => process.env.NODE_ENV !== "production";
const NotImplementedBlock = ({ componentName, ...props }) => {
  if (!isDevelopmentEnvironment()) {
    return null;
  }
  return /* @__PURE__ */ jsx("section", { className: "py-6 lg:py-8", children: /* @__PURE__ */ jsxs("div", { className: "container mx-auto px-4", children: [
    /* @__PURE__ */ jsxs("h2", { className: "mb-6 whitespace-break-spaces text-2xl", children: [
      "Component ",
      componentName ?? "unknown",
      " is not implemented yet!"
    ] }),
    /* @__PURE__ */ jsx(JsonParser, { props })
  ] }) });
};
NotImplementedBlock.displayName = "Engine::NotImplementedBlock";
export {
  NotImplementedBlock
};
//# sourceMappingURL=NotImplementedBlock.js.map
